import { api } from '../../../services/api/apiClient';
import type { ApiResponse } from '../../../types/api';
import type { CompanySettings } from '../types/settingsTypes';

let cache: Promise<CompanySettings> | null = null;

/** Company settings, fetched once per session. */
export function loadSettings(): Promise<CompanySettings> {
  if (!cache) {
    cache = api
      .get<ApiResponse<CompanySettings>>('/settings')
      .then((r) => r.data)
      .catch((err) => {
        cache = null;
        throw err;
      });
  }
  return cache;
}

export const clearSettingsCache = () => {
  cache = null;
};

export const settingsService = {
  get: () => api.get<ApiResponse<CompanySettings>>('/settings').then((r) => r.data),
  update: async (body: Partial<CompanySettings>) => {
    const r = await api.put<ApiResponse<CompanySettings>>('/settings', body);
    clearSettingsCache();
    return r.data;
  },
};
